import { useMutation } from "@tanstack/react-query";
import type { SendMessageRequest } from "@onemileauto/shared-types";
import { sendMessage } from "../lib/api-client";
import { useOutboxToastDispatch } from "./use-outbox-toasts";

/** Wraps POST /messages/send and seeds the outbox toast stack from the direct response — see use-outbox-toasts.tsx for why both this and the WebSocket feed the same reducer. */
export function useSendMessage(mailboxId: string | undefined) {
  const dispatch = useOutboxToastDispatch();

  return useMutation({
    mutationFn: (body: SendMessageRequest) => sendMessage(mailboxId!, body),
    onSuccess: (res) => {
      dispatch({
        type: "seed",
        outboxId: res.outboxId,
        threadId: res.threadId,
        messageId: res.messageId,
        scheduledSendAt: res.scheduledSendAt,
      });
    },
  });
}
